
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 48","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"d":"M42.358 14.325 38 19l-12.5-5L11 20l14 6v-.5L39 20l3.48 4.009.284.333s-.373.163-.406.179l-4.245 1.696v10.009l-14.977 4.756-14.969-4.765V26.21L3.5 24.342l4.554-5.008-4.554-5.01L18.558 8.31 22.5 12.5 27 8l15.358 6.325Z","fill":"#D0EFEC"}}),_c('path',{staticClass:"i-box",attrs:{"d":"M24.862 24.047v15.238m0-15.238 4.74 4.613 9.905-3.978m-14.645-.635 14.645-6.01m-14.645 6.01-14.688-6.01m14.688 6.01-4.698 4.613-9.99-4.019m14.688 14.644 14.645-4.614v-9.99M24.862 39.286 10.174 34.67v-10.03m29.333.04 4.402-1.862-4.402-4.783m0 0-14.645-6.053m14.645 6.053 4.402-4.952L29.603 7.37l-4.741 4.613m-14.688 6.053-4.317 4.868 4.317 1.737m0-6.605 14.688-6.053m-14.688 6.053-4.317-4.952L20.163 7.37l4.699 4.613","stroke":"#234652"}})])
          )
        }
      }
    